import { render } from "./Game.vue?vue&type=template&id=f245ee62&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=f245ee62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kama484\\Monopoly\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f245ee62"]])

export default __exports__